import { useEffect, useState } from 'react';
import { useOrderPay } from './../controller/OrderPayController'
import { Space, Spin, Flex, Layout, Col, Row, Typography } from 'antd';
import { useParams } from 'react-router-dom';

const OrderPay = ({

}) => {
    const { order_id } = useParams();
    const [data, setData] = useState([])
    const onFinish = ({
        axiosMode,
        status,
        responseData
    }) => {
        if (axiosMode === 'post') {
            if (status === 'success') {
                setData(responseData?.data)
                responseData?.data?.forEach(element => {
                    if (String(element.paid) !== '1')
                        window.location.href = element?.json_value?.info?.paymentUrl?.web
                });
                return
            }
        }
    }
    const {
        postOrderPay
    } = useOrderPay({
        onFinish
    })
    useEffect(() => {
        postOrderPay([
            {
                order_id
            }
        ])
    }, [])
    return (<>
        <Layout className="layout">
            <Layout.Header>
                <div className="logo" />
            </Layout.Header>
            <Layout.Content
                style={{
                    padding: '0 50px',
                    textAlign: 'center',
                }}
            >
                <div className="LinePayConfirm">
                    {data?.[0]?.paid !== 1 ?
                        <Spin style={{ height: '50%' }} tip="LinePay 付款驗證中請稍候" fullscreen>
                        </Spin>
                        :
                        <Typography.Text>LinePay 付款已完成</Typography.Text>
                    }
                </div>
            </Layout.Content>
            <Layout.Footer
                style={{
                    textAlign: 'center',
                }}
            >
                Payment System ©2024 Created by Orange Technic
            </Layout.Footer>
        </Layout>
    </>)
}
export default OrderPay